<template>
  <div>
    <div>
      <v-card class="pa-2">
        <v-layout row wrap class="ma-0">
          <v-flex xs7>
            <div style="display: flex">
              <div>
                <v-avatar size="90px">
                  <v-img src="/static/img/avatar-placeholder.png"></v-img>
                </v-avatar>
              </div>
              <div class="ml-3">
                <div style="font-size: small; color: #909090">Warunyoo achayata</div>
                <div style="font-weight: 800">#5221 ติดต่อแอดมิน</div>
                <div style="font-size: 11px; color: grey">
                  <span style="border-right: 2px solid darkgrey; padding-right: 2px"
                    >18 Feb 2021</span
                  >
                  <span style="border-right: 2px solid darkgrey; padding-right: 2px"
                    >Agent responded 1 day</span
                  >
                  <span>Pending for 2 hours</span>
                </div>
                <div class="my-3" style="display: flex">
                  <div class="mr-2">
                    <DropdownMenu :noicon="true" v-model="priority" :options="priorityOptions">
                      <span
                        class="px-3 py-1"
                        style="
                          background-color: rgb(233 233 233);
                          border-radius: 6px;
                          border: 1px solid #b9b9b9;
                        "
                      >
                        <i
                          :style="{ color: priorityColor(priority) }"
                          class="fas fa-circle mr-2"
                        ></i
                        >{{ priority }}
                      </span>
                    </DropdownMenu>
                  </div>
                  <div>
                    <DropdownMenu :noicon="true" v-model="status" :options="statusOptions">
                      <span
                        class="px-3 py-1"
                        style="
                          background-color: rgb(233 233 233);
                          border-radius: 6px;
                          border: 1px solid #b9b9b9;
                        "
                      >
                        {{ status }}
                      </span>
                    </DropdownMenu>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs5>
            <div style="color: darkgrey">
              <div>Group / subgroup</div>
              <div><i class="fas fa-user-tie mr-2"></i>Agent 1</div>
              <div>
                <v-chip dark color="#3b5998">
                  Facebook</v-chip
                >
                <v-chip dark color="#3b5998">
                  Studio 7</v-chip
                >
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      priority: 'Low',
      status: 'Pending',
      priorityOptions: ['Low', 'Medium', 'High'],
      statusOptions: ['Pending', 'Answered', 'Cancel', 'Closed'],
    }
  },
  methods: {
    priorityColor(item) {
      if (item == 'Low') {
        return 'green'
      } else if (item == 'Medium') {
        return 'orange'
      } else if (item == 'High') {
        return 'red'
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/view/ticket2/management/TicketItem.vue